import { HostListener, Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SidebarService {
  showMinisidebar: boolean = false;
  private mobileOpen = false;
  public innerWidth: any;

  constructor() {
    this.handleLayout();
  }
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.handleLayout();
  }
  handleLayout() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1170) {
      this.showMinisidebar = true;
    } else {
      this.showMinisidebar = false;
    }
  }
  setMobileOpen(v: boolean) {
    this.mobileOpen = v;
  }
  getMobileStatus(): boolean {
    return this.mobileOpen;
  }
  toggleMobileOpen() {
    this.mobileOpen = !this.mobileOpen;
  }
  showMiniSidebar() {
    return this.mobileOpen;
  }
  closeSidebar() {
    if (this.innerWidth > 768) return;
    this.showMinisidebar = true;
  }
}
